import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartPageContainerStyles } from "@insite/content-library/Widgets/Cart/CartPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";

import { css } from "styled-components";

cartPageContainerStyles.productCarouselContainer = mergeToNew(cartPageContainerStyles.productCarouselContainer, {
    css: css`
        > [class^="Wrapper"] {
            > div {
                padding: 30px 25px !important;
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border: 0 solid transparent;
                        border-width: 0 1.5rem 1.5rem 0;
                    `,
                    null,
                    css`
                        grid-column-start: 2;
                        -ms-grid-column: 2;
                        grid-row-start: 4;
                        -ms-grid-row: 4;
                    `,
                ],
                "min",
            )}
    `,
});
